import {Component, OnInit}              from '@angular/core';
import {ApDynformsConfigFieldset}       from '../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {ApDynformsConfigTextbox}        from '../../../ap-dynforms/config/ap-dynforms-config-textbox';
import {ApDynformsConfigCheckbox}       from '../../../ap-dynforms/config/ap-dynforms-config-checkbox';
import {ApDynformsConfigDatepicker}     from '../../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {ApDynformsConfigNumerictextbox} from '../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {ApDynformsConfigComboBox}       from '../../../ap-dynforms/config/ap-dynforms-config-combobox';
import {ApDynformsConfigMultiSelect}    from '../../../ap-dynforms/config/ap-dynforms-config-multiselect';
import {GetKendoDateFormatPipe}         from '../../../ap-utils/pipes/get-kendo-date-format.pipe';
import {ApDynformsConfigTimepicker}     from '../../../ap-dynforms/config/ap-dynforms-config-timepicker';
import {ApDynformsConfigPlaceholder}    from '../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {of}                             from 'rxjs';
import {ApDynformsConfigTextarea}       from '../../../ap-dynforms/config/ap-dynforms-config-textarea';
import {SettingsStore}                  from '../../../stores/base-data/settings.store';
import {LanguageStore}                  from '../../../stores/translation/language.store';

@Component({
  selector: 'ap-form-style',
  template: `
      <ap-dyncomponent [caption]="'Global__Sample_Form'"
                       [headerIcon]="'ap-basedata-icon'"
                       [fieldSets]="fieldsets">
          <div class="ap-form-actions" dynforms.action>
              <button type="button"
                      class="k-button k-primary ap-form-button-right">{{'Global_Next_With_Arrow' | translate}}
              </button>
          </div>
      </ap-dyncomponent>`,
})
export class ApFormStyleComponent implements OnInit {
  fieldsets: ApDynformsConfigFieldset[] = [];
  textVal = 'a simple text';
  working = true;

  constructor(private kendoDatePipe: GetKendoDateFormatPipe,
              private settingsStore: SettingsStore,
              private languageStore: LanguageStore) {
  }

  ngOnInit(): void {
    this._buildForm();
  }

  private _buildForm(): void {
    this.fieldsets = [
      new ApDynformsConfigFieldset({
        key: 'Fieldset',
        legend: 'Fieldset',
        columns: 2,
        config: [
          new ApDynformsConfigTextbox({
            key: 'TextBox',
            label: 'TextBox',
            value: this.textVal,
          }),
          new ApDynformsConfigCheckbox({
            key: 'Bool',
            label: 'Bool',
            value: this.working,
          }),
          new ApDynformsConfigDatepicker({
            key: 'Date',
            label: 'Date',
            format: this.kendoDatePipe.transform(this.languageStore.CurrentDateFormat)
          }),
          new ApDynformsConfigTimepicker({
            key: 'Time',
            label: 'Time',
            format: this.kendoDatePipe.transform(this.languageStore.CurrentTimeFormat)
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'Number',
            label: 'Number',
          }),
          new ApDynformsConfigPlaceholder(),
          new ApDynformsConfigComboBox({
            key: 'ComboBox',
            label: 'ComboBox',
            textField: 'text',
            valueField: 'value',
            options: ['eins', 'zwei', 'drei', 'vier', 'fünf', 'sechs', 'sieben', 'acht', 'neun', 'zehn'].map((v, i) => ({text: v, value: i + 1})),
          }),
          new ApDynformsConfigMultiSelect({
            key: 'MultiSelect',
            label: 'MultiSelect',
            options: ['eins', 'zwei', 'drei', 'vier', 'fünf', 'sechs', 'sieben', 'acht', 'neun', 'zehn'],
          }),
          new ApDynformsConfigTextarea({
            key: 'TextArea',
            label: 'TextArea',
            rows: 7
          }),
          new ApDynformsConfigComboBox({
            key: 'ComboBoxLoading',
            label: 'ComboBoxLoading',
            loading: of(true),
            options: ['eins', 'zwei', 'drei', 'vier', 'fünf', 'sechs', 'sieben', 'acht', 'neun', 'zehn'],
          })
        ],
      })
    ];
  }
}
